import {
  MENU_POPOVER_FRAME_CLASS_NAME,
  renderMenuPopoverContent,
} from "@-/dev.improve.haniverse.components.ui.menu-popover-surface";
import { NativeOnlyAnimatedView } from "@-/dev.improve.haniverse.components.ui.native-only-animated-view";
import {
  PortalContextBridgeContent,
  usePortalContextValues,
} from "@-/dev.improve.haniverse.components.ui.portal-context-bridge";
import { TextClassContext } from "@-/dev.improve.haniverse.components.ui.text";
import { cn } from "@-/com.npmjs.cn";
import {
  Content,
  Overlay,
  Portal,
  type ContentProps,
  type ContentRef,
} from "@rn-primitives/popover";
import { Fragment, type RefAttributes } from "react";
import { Platform, StyleSheet } from "@-/com.npmjs.react-native";
import { FadeIn, FadeOut } from "@-/com.npmjs.react-native-reanimated";
import { FullWindowOverlay as RNFullWindowOverlay } from "@-/com.npmjs.react-native-screens";

const PLATFORM_COMPONENTS = {
  ["ios" as string]: RNFullWindowOverlay,
};
const FullWindowOverlay = PLATFORM_COMPONENTS[Platform.OS] ?? Fragment;

export function PopoverContent({
  align = "center",
  className,
  portalHost,
  sideOffset = 4,
  ...props
}: ContentProps &
  RefAttributes<ContentRef> & {
    portalHost?: string;
  }) {
  const contextValues = usePortalContextValues();
  return (
    <Portal hostName={portalHost}>
      <PortalContextBridgeContent values={contextValues}>
        <FullWindowOverlay>
          <Overlay style={Platform.select({ native: StyleSheet.absoluteFill })}>
            <NativeOnlyAnimatedView entering={FadeIn.duration(200)} exiting={FadeOut}>
              <TextClassContext value="text-popover-foreground">
                <Content
                  align={align}
                  className={cn(
                    MENU_POPOVER_FRAME_CLASS_NAME,
                    "z-50 w-72 p-4 outline-hidden",
                    Platform.select({
                      web: cn(
                        "origin-(--radix-popover-content-transform-origin) cursor-auto animate-in fade-in-0 zoom-in-95",
                        props.side === "bottom" && "slide-in-from-top-2",
                        props.side === "top" && "slide-in-from-bottom-2",
                      ),
                    }),
                    className,
                  )}
                  sideOffset={sideOffset}
                  {...props}
                >
                  {renderMenuPopoverContent(props.children, { clipsRows: false })}
                </Content>
              </TextClassContext>
            </NativeOnlyAnimatedView>
          </Overlay>
        </FullWindowOverlay>
      </PortalContextBridgeContent>
    </Portal>
  );
}
